export interface CarryOverEntry {
  id: string;
  storehouseId: number;
  storehouseName: string;
  carryOverPrice: number;
  expendPrice: number;
  incomePrice: number;
  startTime: string;
  endTime: string;
  statisticsTime: string;
  state: number;
}

export function fromJson(
  json: { id?: number } & Record<string, never>
): CarryOverEntry {
  return {
    id: json.id?.toString() || "",
    storehouseId: json.storehouseId,
    storehouseName: json.storehouseName,
    carryOverPrice: json.carryOverPrice,
    expendPrice: json.expendPrice,
    incomePrice: json.incomePrice,
    startTime: json.startTime,
    endTime: json.endTime,
    statisticsTime: json.statisticsTime,
    state: json.state,
  };
}

export interface CarryOverDetailEntry {
  id: number;
  accountUnit: string;
  batchNo: string;
  beginningCount: number;
  carryOverPrice: number;
  closeCount: number;
  doseCategory: string;
  expendCount: number;
  expendPrice: number;
  incomeCount: number;
  incomePrice: number;
  name: string;
  productInfo: string;
  spec: string;
  splitBeginningCount: number;
  splitCloseCount: number;
  splitExpendCount: number;
  splitExpendPrice: number;
  splitIncomeCount: number;
  splitIncomePrice: number;
  splitScale: number;
  statisticsTime: string;
  storehouseId: number;
  storehouseName: string;
  tenantCarryOverId: number;
  tenantInventoryLedgerId: number;
  tenantMaterialsCatalogId: number;
  tenantSupplierName: string;
  unitPrice: number;
}

export interface CarryOverItem {
  id: number;
  category: number;
  chinesePatentPrice: number;
  chinesePrice: number;
  endTime: string;
  instrumentPrice: number;
  restPrice: number;
  startTime: string;
  statisticsTime: string;
  status: number;
  storehouseId: number;
  storehouseName: string;
  tenantCarryOverId: number;
  totalPrice: number;
  westernPrice: number;
}
